/**
 * Normaliza IDs (UUIDs) para chaves estáveis em maps — evita falha de lookup por diferença de maiúsculas/minúsculas ou espaços.
 */
export function idKey(v) {
  if (v == null || v === '') return '';
  return String(v).trim().toLowerCase();
}

/**
 * Extrai array de respostas paginadas ou cruas da API.
 */
export function unwrapList(payload) {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== 'object') return [];
  return payload.data ?? payload.items ?? payload.results ?? [];
}

export function lookupLabel(map, id) {
  if (id == null || id === '') return null;
  const k = idKey(id);
  return map[k] ?? null;
}
